/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { StyleSheet } from 'react-native';
import { List } from 'react-native-paper';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import { SplitBox, TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import TextButton from '../../components/elements/TextButton';

export default function Beta({ navigation, route }: RootStackScreenProps<'Beta'>) {
  const handleSubmit = () => {
    navigation.navigate('Survey', { id: 'ValidDevice' });
  };

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <SplitBox
        flex={[1]}
        mobileView={false}
        style={{
          alignSelf: 'center',
        }}
        key="SplitBox"
      >
        <View
          style={{
            maxWidth: 300,
          }}
          key="ContainerView"
        >
          <Text style={[sc.h4, { textAlign: 'center', marginBottom: 10 }]}>SnapCalorie Program</Text>
          {/* <Text style={[styles.descriptionText, { marginVertical: 10 }]}>
            We are accepting new users who meet the following criteria.
          </Text> */}
          <List.Section>
            <List.Item
              title="One-on-one Guidance"
              description="Our nutrition coaches will be here to support you."
              left={(props) => <List.Icon {...props} icon="phone" />}
            />
            <List.Item
              title="Engage with the Community"
              description="Get support from peers."
              left={(props) => <List.Icon {...props} icon="whatsapp" />}
            />
            <List.Item
              title="LiDAR Devices Only"
              description="Currently SnapCalorie only supports iPhone 12-14 Pro."
              left={(props) => <List.Icon {...props} icon="cellphone" />}
            />
          </List.Section>
          <View style={{ flex: 1, flexDirection: 'row', alignSelf: 'center', padding: 20 }}>
            <TextButton
              onPress={() => {
                handleSubmit();
              }}
              text="Get Started!"
              textStyle={sc.buttonText}
              style={[sc.buttonWrapper, { backgroundColor: '#2364AA', width: 200, margin: 10 }]}
              disabled={false}
            />
          </View>
        </View>
      </SplitBox>
    </SnapCalorieSitePage>
  );
}

const styles = StyleSheet.create({
  descriptionText: {
    ...sc.focusText,
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 10,
  },
  item: {
    ...sc.focusText,
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
    padding: 10,
    height: 20,
    marginTop: 10,
  },
});
